import handleTransformLang from "../functions/handleTransformLang";
import errorPage from "../lang/pages/error.json";
import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  const content = handleTransformLang(errorPage);
  console.error(error);

  return (
    <div className="flex justify-center items-center w-screen h-screen bg-gray-900">
      <div className=" text-gray-300 flex flex-col">
        <div className=" text-6xl flex  justify-center ">
          {error.status}
        </div>
        <div className="flex  justify-center ">
          {content.label}: {error.statusText || error.message}
        </div>
      </div>

    </div>
  );
}
